import { Skeleton } from '@/shared/components/Skeleton';
import { PLP_BROWSE_PAGE_MAX_CLASS } from '@/features/plp/constants';

const PRODUCT_PLACEHOLDERS = 6;

function CategoryNavSkeleton() {
  return (
    <div className="overflow-hidden bg-[#337ab8] px-3 py-2 md:mx-4" aria-hidden>
      <Skeleton className="mb-2 h-4 w-20 rounded bg-white/30" />
      <div className="flex flex-nowrap gap-1.5 overflow-hidden whitespace-nowrap md:flex-wrap">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-8 w-16 shrink-0 rounded bg-white/40" />
        ))}
      </div>
    </div>
  );
}

function ProductPlaceholder() {
  return (
    <div className="flex flex-col gap-2" aria-hidden>
      <Skeleton className="aspect-square w-full rounded-md" />
      <Skeleton className="h-3 w-full rounded" />
      <Skeleton className="h-3 w-[70%] rounded" />
    </div>
  );
}

/** Loading skeleton for recently-viewed — mirrors loaded layout without heavy card chrome. */
export function RecentlyViewedSkeleton() {
  return (
    <div aria-label="Loading recently viewed designs">
      <div className={PLP_BROWSE_PAGE_MAX_CLASS}>
        <CategoryNavSkeleton />
      </div>
      <div className={`${PLP_BROWSE_PAGE_MAX_CLASS} px-4 pb-8 pt-4`}>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
          {Array.from({ length: PRODUCT_PLACEHOLDERS }).map((_, i) => (
            <ProductPlaceholder key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
